var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_11674_21786)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.244 9.61709C2.36372 8.53354 1.12947 5.8003 3.60277 2.28886C1.83178 3.63237 0.79361 5.76977 0.79361 8.18198C0.79361 10.5942 2.93101 15.1133 8.03025 15.1133C12.1096 15.1133 14.9616 11.8156 14.7173 10.2278C14.473 8.64 12.0303 8.85374 10.5035 9.25068C7.95419 9.91352 6.04552 10.6553 4.244 9.61709Z",
    fill: "url(#paint1_linear_11674_21786)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27468 6.28916C2.39441 7.37271 2.38155 10.7166 3.63346 13.6174C0.580022 11.2724 0.5902 7.79551 0.976968 6.35022C1.4248 4.4978 3.41972 0.792969 7.81666 0.792969C12.2136 0.792969 14.2696 4.04997 14.748 5.67846C14.9922 7.44946 11.9693 9.34259 9.70979 7.44946C7.69069 5.75777 6.07621 5.25099 4.27468 6.28916Z",
    fill: "url(#paint2_linear_11674_21786)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20816 6.61141C3.547 7.56597 3.53564 10.5118 4.64166 13.0672C1.94405 11.0014 1.95304 7.93844 2.29474 6.66521C2.69039 5.03331 4.45282 1.76953 8.33738 1.76953C12.2219 1.76953 14.0383 4.63879 14.4609 6.07342C14.6768 7.63358 12.0061 9.30134 10.0099 7.63358C8.22608 6.14329 6.79975 5.69684 5.20816 6.61141Z",
    fill: "url(#paint3_linear_11674_21786)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.813 10.0986C12.6647 9.60654 13.4381 6.76402 13.0311 4.0094C15.1021 6.70307 14.3007 9.65931 13.6411 10.8007C12.8366 12.2746 10.2895 14.971 6.53727 13.9656C2.78509 12.9602 1.77321 9.71863 1.73629 8.2235C1.93164 6.66064 4.94292 5.74092 6.43948 7.86851C7.77679 9.76971 9.03897 10.5701 10.813 10.0986Z",
    fill: "url(#paint4_linear_11674_21786)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11674_21786",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11674_21786",
    x1: 13.3432,
    y1: 10.2583,
    x2: 3.99972,
    y2: 2.31939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#831CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542419,
    stopColor: "#E50EE9",
    stopOpacity: 0.457581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6303D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11674_21786",
    x1: 12.7632,
    y1: 5.92274,
    x2: 2.47315,
    y2: 11.7243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F52872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499947,
    stopColor: "#F5A328",
    stopOpacity: 0.500053
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11674_21786",
    x1: 12.7075,
    y1: 6.28862,
    x2: 3.62908,
    y2: 11.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F52872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499947,
    stopColor: "#F5A328",
    stopOpacity: 0.500053
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11674_21786",
    x1: 3.48569,
    y1: 8.46946,
    x2: 13.5833,
    y2: 5.86103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F52872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499947,
    stopColor: "#F5A328",
    stopOpacity: 0.500053
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52872",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotIcon);
export default __webpack_public_path__ + "static/media/copilot_icon.7ec904709fc56ab4b1d76202b24195ec.svg";
export { ForwardRef as ReactComponent };